<template>
  <div>
    <v-card class="mx-auto" width="95%">
      <v-card-title>
        <v-toolbar-title>Listar de Autores</v-toolbar-title>
      </v-card-title>
      <v-toolbar color="darken-1" class="mb-1" elevation="0">
        <v-row>
          <v-col cols="12" sm="12" md="5">
            <mb-text-field
              v-model="search"
              :soloInverted="true"
              prependInnerIcon="search"
              label="Buscar por nome" />
          </v-col>
        </v-row>
      </v-toolbar>
      <v-data-table
        :headers="columns"
        :items="autores"
        :items-per-page="5"
        :search="search"
        :custom-filter="nomeFilter"
        class="elevation-0"
      >
        <template v-slot:item="row">
          <tr>
            <td>
              <v-avatar size="32px">
                <v-img :src="row.item.foto" v-if="!!row.item.foto && row.item.foto !== 'null'"></v-img>
                <v-icon large v-else>mdi-account-circle</v-icon>
              </v-avatar>
            </td>
            <td>{{ row.item.nome }}</td>
            <td>{{ row.item.email }}</td>
            <td>{{ row.item.contato }}</td>
            <td>
              <v-btn x-small class="mb-2" text @click="carregarEditarModal(row.item)">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn x-small class="mb-2" text @click="deletarAutor(row.item.id)">
                <v-icon dark>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-toolbar color="darken-1" class="mb-1" elevation="0">
        <v-btn
          dark rounded
          color="darken-2"
          class="text-transform-none"
          @click="mostrarNovoAutor()"
        ><v-icon>add</v-icon>Novo Autor</v-btn>
      </v-toolbar>
    </v-card>
    <v-dialog v-model="dlgNovoAutor" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="darken-2" elevation="0" @short="true">
          <v-btn icon dark @click="dlgNovoAutor = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span v-if="isNew">Novo Autor</span>
            <span v-else>Editar Autor</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="salvarAutor()">Salvar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <mb-text-field
                  v-model="autor.nome"
                  prependIcon="perm_identity"
                  label="Nome"
                  required />
              </v-col>
              <v-col cols="12" md="6">
                <mb-text-field
                  v-model="autor.email"
                  prependIcon="email"
                  label="Email" />
              </v-col>
              <v-col cols="12" md="6">
                  <mb-text-field
                    label="Contato"
                    prependIcon="phone"
                    v-model="autor.contato" />
              </v-col>
              <v-col cols="12">
                <v-file-input
                  :rules="rules"
                  v-model="fotoUpload"
                  show-size
                  accept="image/png, image/jpeg"
                  placeholder="Escolher foto"
                  prepend-icon="mdi-camera"
                  label="Foto"

                  @change="imageToBase64"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-spacer />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AutorService from "../services/autorService";
import AutorInput from "../classes/autorInput";
export default {
  data() {
    return {
      columns: [
        { text: "" },
        { text: "Nome", align: "center" },
        { text: "Email", align: "center" },
        { text: "Contato", align: "center" },
        { text: "" }
      ],
      rules: [
        value =>
          !value ||
          value.size < 2000000 ||
          "Imagem não pode ser maior que 2 MB!"
      ],
      autores: [],
      search: "",
      isNew: true,
      dlgNovoAutor: false,
      autor: new AutorInput(),
      fotoUpload: null
    };
  },
  methods: {
    mostrarNovoAutor() {
      this.isNew = true;
      this.autor = new AutorInput();
      this.fotoUpload = null;
      this.dlgNovoAutor = true;
    },
    async salvarAutor() {
      if (this.isNew) {
        AutorService.criarAutor(this.autor)
          .then(result => {
            if (result.data.errors) {
              this.$toast.error(result.data.errors);
            } else {
              this.autores.push(result.data.data.criarAutor);
              this.$toast.info("Autor salvo com sucesso.");
              this.dlgNovoAutor = false;
            }
          })
          .catch(error => {
            this.$toast.error("Erro ao salvar autor. " + error);
          });
      } else {
        AutorService.atualizarAutor(this.autor)
          .then(result => {
            if (result.data.errors) {
              this.$toast.error(result.data.errors);
            } else {
              this.autores.push(result.data.data.criarAutor);
              this.$toast.info("Autor salvo com sucesso.");
              this.dlgNovoAutor = false;
            }
          })
          .catch(error => {
            this.$toast.error("Erro ao salvar autor. " + error);
          });
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result); //.substr(reader.result.indexOf(',') + 1)
        reader.onerror = error => reject(error);
      });
    },
    imageToBase64() {
      let foto = this.fotoUpload;
      this.getBase64(foto).then(data => (this.autor.foto = data));
    },
    async carregarAutores() {
      var result = await AutorService.listarAutor();
      this.dlgNovoAutor = false;
      this.autores = result.data.data.listarAutor;
    },
    carregarEditarModal(autor) {
      this.isNew = false;
      this.fotoUpload = null;
      this.autor = new AutorInput();
      this.autor = autor;
      this.dlgNovoAutor = true;
    },
    async deletarAutor(autorId) {
      var result = await AutorService.deletarAutor(autorId);
      if (result.data.errors) {
        this.$toast.error("Não é possivel remover o autor.");
      } else {
        this.$toast.info("Autor removido com sucesso.");
        await this.carregarAutores();
      }
    },
    onButtonClick(item) {
      console.log("click on " + item.no);
    },
    nomeFilter(items, filters, filter) {
      return filter.nome.toLowerCase().includes(filters.toLowerCase());
    }
  },
  updated() {},
  created() {
    this.carregarAutores();
  },
  components: {
  }
};
</script>
<style></style>
